import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import SvgMinus from '@nexus/lib-react/dist/core/Icon/icons/default/Minus';
import styled from '../../../../../../theme/styled';

const RemoveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
`;

const StyledButtonTertiaryDark = styled(ButtonTertiaryDark)`
  max-width: 150px;
`;

const StyledParagraph3 = styled(Paragraph4)`
  text-transform: none;
  font-weight: bold;
`;

const MinusIcon = styled(SvgMinus)`
  padding-right: 8px;
`;

export default {
  RemoveButtonContainer,
  StyledButtonTertiaryDark,
  StyledParagraph3,
  MinusIcon,
};
